import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import { format, isToday, isYesterday } from "date-fns";
import { colorGrayLight } from "../../styles/theme";

interface ChatDateDividerProps {
	timestamp: number;
}

const getDateLabel = (timestamp: number) => {
	if (isToday(timestamp)) return "Today";
	if (isYesterday(timestamp)) return "Yesterday";
	return format(timestamp, "d MMM yyyy");
};

const ChatDateDivider: FunctionComponent<ChatDateDividerProps> = ({
	timestamp,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: "10px",
				marginBlock: "4px",
			}}
		>
			<Box sx={{ flex: 1, borderTop: `1px solid ${colorGrayLight}` }} />
			<Typography variant="caption">{getDateLabel(timestamp)}</Typography>
			<Box sx={{ flex: 1, borderTop: `1px solid ${colorGrayLight}` }} />
		</Box>
	);
};

export default ChatDateDivider;
